import React from 'react'

import ModalFormBuilder from 'Skelet/src/components/ModalFormBuilder.js'

import config from '../config.js'


export default class extends React.Component {

  render() {
    return <ModalFormBuilder
      config = {config}
      shouldShow = {this.props.shouldShow}
      close = {this.props.close}
      fields = {[{type:"labels", dbcol:"labels"},
        {type:"hidden", dbcol:"contact_ids"}]}
      label_list = {this.props.label_list}
      update_data = {this.props.update_data}
      api_method = "PATCH"
      api_endpoint = "/contacts-add-label"
      api_block = "contacts_add_label"
      api_block_clear = "contact_list"
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/ModalAddLabel.js